<template>
  <b-col class="p-0 m-0 container__create-reference">
    <div class="my-u5">
      <h5 v-if="enableMode" class="font-weight-bold my-u5 text__method-reference">
        {{ mode }} Reference
      </h5>
      <div v-if="mode === 'view'" class="d-flex justify-content-between">
        <h5 class="font-weight-bold">Reference</h5>
        <b-button v-if="isOwner && !isPublished" variant="primary" @click="onEditing">
          Edit
        </b-button>
      </div>
    </div>
    <b-form class="form__create-reference" @submit.prevent="onSubmit">
      <div v-if="enableForm.content">
        <label for="method-component-content" class="mb-3">
          Content
          <span class="text-danger">*</span>
        </label>
        <base-text-editor
          id="method-component-content"
          :key="enableMode"
          v-model="$v.formReference.$model"
          :toolbar="toolbar"
          placeholder="Insert your content"
          :show-toolbar="enableMode"
          :class="{
            'text-editor__required': $v.formReference.$error
          }"
          class="text__reference-content"
          :disabled="mode === 'view'"
        >
        </base-text-editor>
        <div v-if="$v.formReference.$error" ref="input__error-required" class="text_feedback">
          Content is required
        </div>
      </div>
      <div class="d-flex">
        <b-button v-if="enableMode" class="button__create-method" type="submit" variant="primary">
          {{ actionTitle }}
        </b-button>
        <!-- //delete button -->
        <!-- <div v-if="!enableMode && isDeletable">
          <b-button
            :class="`button__method-${actionButtonModal.toLowerCase()}`"
            type="reset"
            variant="link"
            @click="activeModal()"
          >
            {{ actionButtonModal }}
          </b-button>
        </div> -->
      </div>
    </b-form>
    <ModalConfirmDelete
      :show-modal="isShowModal"
      :action-title="actionButtonModal"
      @confirmed="confirmCancel"
      @canceled="isShowModal = false"
    />
  </b-col>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import BaseTextEditor from '@/components/base-components/BaseTextEditor';
import ModalConfirmDelete from './ModalConfirmDelete.vue';
export default {
  components: {
    BaseTextEditor,
    ModalConfirmDelete
  },
  props: {
    mode: {
      type: String,
      default: 'create'
    },
    reference: {
      type: String,
      default: ''
    },
    isPublished: {
      type: Boolean,
      default: false
    },
    isOwner: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShowModal: false,
      formReference: '',
      enableForm: {
        content: true
      },
      tempIndex: null,
      toolbar: [
        ['bold', 'italic', 'underline'],
        [{ header: '1' }, { header: '2' }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ align: [] }],
        ['link']
      ]
    };
  },
  computed: {
    actionButtonModal() {
      return this.mode === 'create' || this.mode === 'edit' ? 'Cancel' : 'Delete';
    },
    actionTitle() {
      return this.mode === 'create' ? 'Create' : 'Save';
    },
    enableMode() {
      return this.mode === 'create' || this.mode === 'edit';
    },
    isDeletable() {
      return !!this.reference;
    }
  },

  watch: {
    mode: {
      immediate: true,
      handler(mode) {
        if (mode === 'edit') {
          this.$set(this.enableForm, 'content', true);
        }
      }
    }
  },
  validations: {
    formReference: {
      required
    }
  },
  created() {
    this.initDataForm();
  },
  methods: {
    initDataForm() {
      this.$set(this, 'formReference', this.reference);

      if (this.mode === 'view') {
        if (!this.formReference) {
          this.$set(this.enableForm, 'content', false);
        }
      }
    },
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.$emit('submit:method-reference', this.formReference);
    },
    onEditing() {
      this.$emit('editing');
    },
    changeCancel(index) {
      this.tempIndex = index;
      this.activeModal();
      // this.$emit('update:selectedIndex', null);
    },
    confirmCancel(actionTitle) {
      this.isShowModal = false;

      if (this.mode === 'view') {
        this.$emit('delete', { id: this.methodComponent.id, index: this.tempIndex });
      } else {
        this.$emit('canceled:method-reference', this.tempIndex);
      }
      if (actionTitle === 'Cancel' && this.tempIndex === null) {
        this.resetForm();
      }
      // this.goBackToPreviousMethodComponent();
    },
    activeModal() {
      this.isShowModal = true;

      // this.$emit('activeModal', this.tempIndex);
    }
  }
};
</script>

<style lang="scss" scoped>
.text__method-reference {
  text-transform: capitalize;
  size: 20px;
  font-weight: 700;
}
.form__create-reference {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
</style>
